"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.map = exports.head = exports.props = exports.pipe = void 0;

var _sanctuary = require("sanctuary");

var _create = (0, _sanctuary.create)({
  checkTypes: false,
  env: _sanctuary.env
}),
    pipe = _create.pipe,
    props = _create.props,
    head = _create.head,
    map = _create.map;

exports.map = map;
exports.head = head;
exports.props = props;
exports.pipe = pipe;
//# sourceMappingURL=sanctuary.js.map